<script lang="ts">
	import { Button, Text } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import DistanceOnboardingModal from '../Modals/Onboarding/Distance/DistanceOnboardingModal.svelte';

	export let device;

	let showModal = false;
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_quick_tour_guide', {
		default:
			"Even if you've already set up your device, you can still revisit the setup tour anytime to review features or adjust settings.",
	})}
</Text>

<Button
	size="m"
	width="full"
	on:click={() => {
		showModal = true;
	}}
>
	{$format('alert_cta_start_setup', { default: 'Start configuration' })}
</Button>

<DistanceOnboardingModal {device} bind:showModal />
